export function V4LoaderArrow() {
  return (
    <svg width="58" height="23" viewBox="0 0 58 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.75 11.4095H56.5188M56.5188 11.4095L45.8593 0.75M56.5188 11.4095L45.9747 21.9536"
        stroke="url(#v4arrow-gradient)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="v4arrow-gradient"
          x1="44.5188"
          y1="11.3518"
          x2="0.75"
          y2="11.3518"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#EBEBEB" />
        </linearGradient>
      </defs>
    </svg>
  )
}
